import React from 'react';
export const ArrowDownIcon = (props) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", ...props },
    React.createElement("path", { d: "M11.999 15L6 9.759 6.657 9l5.342 4.666L17.343 9l.657.759z" })));
export const ArrowUpIcon = (props) => (React.createElement(ArrowDownIcon, { ...props, style: { transform: 'scaleY(-1' } }));
//# sourceMappingURL=arrow-icon.js.map